import moment from 'moment';
import update from 'immutability-helper';

import * as FavouriteActions from './favourite.action';

import {INITIAL_STATE} from './favourite.state';

export const FavouriteReducer = (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case FavouriteActions.FAVOURITES_FETCH_SUCCESS: {
      return {
        ...state,
        list: payload
          ? payload.map(item => {
              const {search} = item;
              search.searchTime = null;
              return item;
            })
          : []
      };
    }

    case FavouriteActions.FAVOURITE_AUDIT: {
      const updated = {...state};
      return update(updated, {
        list: {
          $apply: favourites =>
            favourites.map(fav => {
              fav.search.searchTime = fav.search.hash === payload.hash ? moment().utc() : fav.search.searchTime;
              return fav;
            })
        }
      });
    }
    case FavouriteActions.FAVOURITE_ADD_SUCCESS: {
      const updated = {...state};
      payload.search.searchTime = moment().utc();
      return update(updated, {list: {$push: [payload]}});
    }

    case FavouriteActions.FAVOURITE_UPDATE_SUCCESS: {
      const toUpdate = {...state};
      const {updated} = payload;
      return update(toUpdate, {
        list: {
          $apply: current => {
            return current.map(item => {
              if (item.id === updated.id) {
                item = {...item, ...updated};
              }

              return item;
            });
          }
        }
      });
    }

    case FavouriteActions.FAVOURITE_REMOVE_SUCCESS: {
      const favourite = state.list.find(fav => fav.id === payload.id);
      if (!favourite) {
        return state;
      }

      return update(
        {...state},
        {
          list: {
            $apply: favourites => favourites.filter(f => f.id !== payload.id)
          },
          removedList: {$push: [favourite]}
        }
      );
    }

    case FavouriteActions.FAVOURITE_RESTORE_SUCCESS: {
      let updated = {...state};

      payload.restoredFavourites.forEach(restored => {
        restored.search.searchTime = null;
        updated = update(updated, {
          list: {$push: [restored]},
          removedList: {
            $apply: removedFavourites => removedFavourites.filter(fav => restored.id !== fav.id)
          }
        });
      });

      return updated;
    }

    case FavouriteActions.FAVOURITES_FETCH_FAILED:
    case FavouriteActions.FAVOURITE_ADD_FAILED:
    case FavouriteActions.FAVOURITE_UPDATE_FAILED:
    case FavouriteActions.FAVOURITE_REMOVE_FAILED:
    case FavouriteActions.FAVOURITE_RESTORE_FAILED:
      return {
        ...state,
        error: payload
      };

    default:
      return state;
  }
};
